import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1E3A5F] text-white pt-16 pb-8" data-id="element-61">
      <div className="container mx-auto px-4 md:px-6" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-63">
          {/* Brand Column */}
          <div className="space-y-4" data-id="element-64">
            <div data-id="element-65">
              <h3 className="text-xl font-bold leading-none" data-id="element-66">LUCKY DUCK</h3>
              <p className="text-xs text-gray-300 tracking-wider" data-id="element-67">
                BATHROOM COMPANY
              </p>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-68">
              Lucky ducks like you deserve the best! We provide quality
              craftsmanship, honest pricing, and stress-free bathroom remodeling
              for Northern Indiana.
            </p>
            <div className="flex gap-4" data-id="element-69">
              <a href="https://www.facebook.com/luckyduckbath" target="_blank" rel="noopener noreferrer" className="h-10 w-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#8BA888] transition-colors" aria-label="Visit our Facebook page" data-id="element-70">
                <Facebook className="h-5 w-5" data-id="element-71" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-72">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-73">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-74">
              <li data-id="element-75">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-76">
                  Home
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-78">
                  About Us
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-80">
                  Contact
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-82">
                  Request Consultation
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-83">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-84">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-85">
              <li data-id="element-86">
                <Link to="/services/full-bathroom-remodeling" className="text-gray-300 hover:text-white transition-colors" data-id="element-87">
                  Full Bathroom Remodeling
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/services/tub-to-shower-conversion" className="text-gray-300 hover:text-white transition-colors" data-id="element-89">
                  Tub-to-Shower Conversions
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/services/custom-tile-work" className="text-gray-300 hover:text-white transition-colors" data-id="element-91">
                  Custom Tile Work
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/services/vanity-installation" className="text-gray-300 hover:text-white transition-colors" data-id="element-93">
                  Vanity Installation
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/services/accessibility-upgrades" className="text-gray-300 hover:text-white transition-colors" data-id="element-95">
                  Accessibility Upgrades
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/services/flooring-and-lighting" className="text-gray-300 hover:text-white transition-colors" data-id="element-97">
                  Flooring & Lighting
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-98">
            <h4 className="text-lg font-semibold mb-6 text-[#8BA888]" data-id="element-99">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-100">
              <li className="flex items-start gap-3" data-id="element-101">
                <MapPin className="h-5 w-5 text-[#8BA888] shrink-0 mt-0.5" data-id="element-102" />
                <span className="text-gray-300" data-id="element-103">
                  Serving Northern Indiana
                  <br data-id="element-104" />
                  and surrounding areas
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-105">
                <Phone className="h-5 w-5 text-[#8BA888] shrink-0" data-id="element-106" />
                <a href="tel:5749141522" className="text-gray-300 hover:text-white transition-colors" data-id="element-107">
                  (574) 914-1522
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-108">
                <Mail className="h-5 w-5 text-[#8BA888] shrink-0" data-id="element-109" />
                <a href="mailto:info@luckyduckbath.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-110">
                  info@luckyduckbath.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-400" data-id="element-111">
          <p data-id="element-112">
            &copy; {new Date().getFullYear()} Lucky Duck Bathroom Company. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}